import React from 'react';

const MIN_HEADER_LEVEL = 1;
const MAX_HEADER_LEVEL = 6;

const isValidHeaderLevel = (headerLevel: number | undefined): boolean => {
  return !headerLevel || headerLevel > MIN_HEADER_LEVEL || headerLevel < MAX_HEADER_LEVEL;
};

interface TitleProps {
  title: string | undefined;
  titleLevel: number | undefined;
}

export const Title = ({ title, titleLevel }: TitleProps) => {
  if (!title || !isValidHeaderLevel(titleLevel)) return null;

  const HeaderTag = titleLevel ? (`h${titleLevel}` as keyof JSX.IntrinsicElements) : 'h2';

  return <HeaderTag dangerouslySetInnerHTML={{ __html: title || '' }} />;
};
